module.exports = __webpack_public_path__ + "static/media/back-img.8d13a100.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back-img.svg
// module id = 230
// module chunks = 0